module.exports = __webpack_public_path__ + "static/media/1_graph2.712cfea3.svg";